module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n\n          " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-004378de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common-template/Footer.vue
// module id = 1407
// module chunks = 7